export default "__VITE_ASSET__RJgH52zF__"